import React from 'react'
import styled from 'styled-components/native'

import { getProfileHookConfig } from 'features/navigation/navigators/ProfileStackNavigator/getProfileHookConfig'
import { useGoBack } from 'features/navigation/useGoBack'
import { AccessibilityRole } from 'libs/accessibilityRole/accessibilityRole'
import { BulletListItem } from 'ui/components/BulletListItem'
import { ExternalTouchableLink } from 'ui/components/touchableLink/ExternalTouchableLink'
import { VerticalUl } from 'ui/components/Ul'
import { Link } from 'ui/designSystem/Link/Link'
import { PageWithHeader } from 'ui/pages/PageWithHeader'
import { Typo } from 'ui/theme'
import { DOUBLE_LINE_BREAK, LINE_BREAK } from 'ui/theme/constants'

export function RecommendedPaths() {
  const { goBack } = useGoBack(...getProfileHookConfig('Accessibility'))
  const groupLabel = 'Méthodes pour obtenir le crédit'
  return (
    <PageWithHeader
      title="Parcours recommandés web"
      onGoBack={goBack}
      scrollChildren={
        <React.Fragment>
          <Typo.Body>
            En complément de la mise en conformité du pass Culture au regard des critères du RGAA
            qui reste partielle, les équipes du pass Culture se sont attachées à travailler des
            parcours critiques pour l’utilisation de son dispositif.
            {DOUBLE_LINE_BREAK}
            En particulier, l’obtention du crédit pass Culture peut se faire selon trois méthodes en
            fonction de sa situation&nbsp;:
          </Typo.Body>
          <StyledVerticalUl>
            <BulletListItem
              groupLabel={groupLabel}
              index={0}
              total={3}
              text="en indiquant ses identifiants EduConnect"
            />
            <BulletListItem
              groupLabel={groupLabel}
              index={1}
              total={3}
              text="en présentant sa carte d’identité"
            />
            <BulletListItem
              groupLabel={groupLabel}
              index={2}
              total={3}
              text="en remplissant un formulaire sur&nbsp;"
              accessibilityRole={AccessibilityRole.LINK}>
              <ExternalTouchableLink
                as={Link}
                isInsideText
                size="extraSmall"
                wording="Démarche Numérique"
                externalNav={{ url: 'https://demarche.numerique.gouv.fr/' }}
                accessibilityRole={AccessibilityRole.LINK}
              />
            </BulletListItem>
          </StyledVerticalUl>

          <Typo.Body>
            Pour les utilisateurs en situation de handicap, il est recommandé d’utiliser ses
            identifiants EduConnect ou de passer par la plateforme Démarche Numérique.
            {LINE_BREAK}
            Ces sites étant gérés par la Direction Interministérielle du Numérique ou par le
            Ministère de l’Éducation Nationale de la Jeunesse et des Sports, leur niveau
            d’accessibilité est maintenu dans le temps.
          </Typo.Body>
        </React.Fragment>
      }
    />
  )
}
const StyledVerticalUl = styled(VerticalUl)(({ theme }) => ({
  marginVertical: theme.designSystem.size.spacing.xl,
}))
